var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-start":"","row":"","mt-4":""}},[_c('div',{staticClass:"mb-3"},[_c('span',{staticClass:"page-side text-uppercase"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }